import { createContainer } from 'react-sweet-state';

import { AudienceTargetingStore } from './AudienceTargetingStore';

export const AudienceTargetingStoreContainer = createContainer(AudienceTargetingStore, {
  onInit:
    () =>
    ({ setState }, { state }) => {
      if (state) {
        setState(state);
      }
    },
  onUpdate:
    () =>
    ({ setState }, { state }) => {
      if (state) {
        setState(state);
      }
    },
});
